import { Button, Card, Popconfirm } from "antd";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { deleteAllUsers } from "../../redux/actions/network";
import {
  createActividadesPreguntas,
  createActividadesRespuestas
} from "../../redux/actions/actividades";

import Excel from "./forms/student/excel";
import Typography from "antd/es/typography";

class Home extends PureComponent {
  render() {
    return (
      <div>
        <Card>
          <Typography level={4}>
            URL DE DB: {process.env.REACT_APP_DATABASE_URL}
          </Typography>
          <Typography level={4}>
            URL DE BACKEND: {process.env.REACT_APP_BACKEND_URL}
          </Typography>
          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="primary">
              <Link to="/viajes/new">Crear un Viaje</Link>
            </Button>
          </Card.Grid>
          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="info">
              <Link to="/viajes">Ver lista de viajes</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="info">
              <Link to="/users">Ver lista de Usuarios</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="info">
              <Link to="/grupos">Ver grupos de Alumnos</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="primary">
              <Link to="/student/new">Añadir nuevo alumno</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="primary">
              <Link to="/profesores/new">Añadir Profesor a plataforma</Link>
            </Button>
          </Card.Grid>
          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="primary">
              <Link to="/grupos/new">Crear Grupo</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }} />

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="dashed" shape="round">
              <Link to="/actividades"> Todas las Actividades</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Excel />
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Button type="primary">
              <Link to="/actividades/new">Crear Actividad</Link>
            </Button>
          </Card.Grid>

          <Card.Grid style={{ width: "50%", textAlign: "center" }}>
            <Card.Grid style={{ width: "50%", textAlign: "center" }}>
              <Button
                style={{ background: "blue", color: "white" }}
                onClick={() => this.props.createActividadesPreguntas()}
              >
                Viajes a Preguntas Normalizer
              </Button>
            </Card.Grid>
            <Card.Grid style={{ width: "50%", textAlign: "center" }}>
              <Popconfirm title="Are you sure？" okText="Yes" cancelText="No">
                <Button
                  style={{ background: "red", color: "white" }}
                  onClick={() => this.props.deleteAllUsers()}
                >
                  Delete all users
                </Button>
              </Popconfirm>
              <Button
                style={{ background: "red", color: "white" }}
                onClick={() => this.props.createActividadesRespuestas()}
              >
                actividades a respuestas Normalizer
              </Button>
            </Card.Grid>
          </Card.Grid>
        </Card>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      deleteAllUsers,
      createActividadesPreguntas,
      createActividadesRespuestas
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(Home);
